// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f8111d88","979":"1888ac00"}[chunkId] + ".chunk.js";
};